import { schema } from 'normalizr';

const category = new schema.Entity('categories');

export const categories = new schema.Array(category);

export default category;
